import ForgotPassword from "./ForgotPassword";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import Accordion from "./Accordion";
import Navbar from "./Navbar";
import ThemeSwitcher from "./ThemeSwitcher";
import Hero from "./Hero";
import Product from "./Product";
import InvitationForm from "./InvitationForm";
import InvitationHero from "./InvitationHero";
import Datepicker from "./Datepicker";
import InvitationPreview from "./InvitationPreview";
import InvitationCounter from "./InvitationCounter";
import Timeline from "./InvitatonTimelineWithQuote";
import Drawer from "./Drawer";
import Table from "./Table";
import TableRowSkeleton from "./TableRowSkeleton";
import MessageAccordion from "./AccordionMessage";
import TemplateCard from "./TemplateCard";
import Invitation2 from "./Invitation2";
import InvitationForm2 from "./InvitationForm2";
import SvgImg from "./SVG";
import AboutUs from "./About";
import Features from "./Features";
import HowItWorks from "./HowItWorks";
import Footer from "./Footer";
import Portfolio from "./Portofolio";
import Pricing from "./Pricing";
import Testimonials from "./Testimonials";
import Modal from "./Modal";
import InviteNotFound from "./InviteNotFound";
import AlertComponent from "./Alert";
import ResetPassword from "./ResetPassword";
import { TestimonialCard } from "./Testimonials";
import PatternCard from "./PatternCard";
import {
  Label,
  SliderField,
  CheckboxField,
  InputField,
  ImageUploadField,
  SlugInputField,
  DatePickerField,
  ColorPickerField,
  SelectField,
} from "./InputFields";

import {
  GoogleSVG,
  ErrorSVG,
  InviteSVG,
  EditSVG,
  PeopleSVG,
  ActivateSVG,
  ShareSVG,
  DissmissSVG,
  SuccessPaymentSVG,
  NotFoundSVG,
  ToggleNavigationSVG,
  UploadImageSVG,
  AccordionOpenSVG,
  AccordionClosedSVG,
  NavbarBurgerMenu,
  NavbarBurgerMenuOpen,
  TopRightArrowSVG,
  DeleteSVG,
  DefaultAvatarSVG,
  FeaturesDesignSVG,
  FeaturesTableSVG,
  FeaturesListSVG,
  FeaturesMegaphoneSVG,
  LogoSVG,
  StarRating,
  PencilSVG,
  PencilOffSVG,
  CheckmarkSVG,
  NoGuestsSVG,
  InfoSVG,
  PersonalMessageSVG,
  RemoveGuestSVG,
  AddGuestSVG,
  FontSVG,
  FontPlusSVG,
  FontMinusSVG,
  ColorPalleteSVG,
} from "./SVG";

export const SVGS = {
  GoogleSVG,
  ErrorSVG,
  InviteSVG,
  EditSVG,
  PeopleSVG,
  ActivateSVG,
  ShareSVG,
  DissmissSVG,
  SuccessPaymentSVG,
  NotFoundSVG,
  ToggleNavigationSVG,
  UploadImageSVG,
  AccordionOpenSVG,
  AccordionClosedSVG,
  DefaultAvatarSVG,
  NavbarBurgerMenu,
  NavbarBurgerMenuOpen,
  TopRightArrowSVG,
  DeleteSVG,
  FeaturesDesignSVG,
  FeaturesTableSVG,
  FeaturesListSVG,
  FeaturesMegaphoneSVG,
  LogoSVG,
  StarRating,
  PencilSVG,
  PencilOffSVG,
  CheckmarkSVG,
  NoGuestsSVG,
  InfoSVG,
  PersonalMessageSVG,
  RemoveGuestSVG,
  AddGuestSVG,
  FontSVG,
  FontPlusSVG,
  FontMinusSVG,
  ColorPalleteSVG,
};
export {
  LoginForm,
  SignupForm,
  ForgotPassword,
  Accordion,
  Navbar,
  ThemeSwitcher,
  Hero,
  Product,
  InvitationForm,
  InvitationHero,
  Datepicker,
  InvitationPreview,
  InvitationCounter,
  Timeline,
  Drawer,
  Table,
  TableRowSkeleton,
  MessageAccordion,
  TemplateCard,
  Invitation2,
  InvitationForm2,
  SvgImg,
  AboutUs,
  Features,
  HowItWorks,
  Footer,
  Portfolio,
  Pricing,
  Testimonials,
  Modal,
  InviteNotFound,
  AlertComponent,
  ResetPassword,
  TestimonialCard,
  PatternCard,
  Label,
  SliderField,
  CheckboxField,
  InputField,
  ImageUploadField,
  SlugInputField,
  DatePickerField,
  ColorPickerField,
  SelectField,
};
